import { useEffect, useState } from "react";
import api, { API } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Card } from "@/components/ui/card";
import ImagePicker from "@/components/ImagePicker";
import { toast } from "sonner";
import { Save, Image as ImageIcon } from "lucide-react";

const abs = (u) => (!u ? "" : u.startsWith("http") ? u : `${API.replace("/api", "")}${u}`);

export default function WelcomeAdmin() {
  const [w, setW] = useState(null);
  const [pick, setPick] = useState(false);
  useEffect(() => { api.get("/welcome").then((r) => setW(r.data)); }, []);
  if (!w) return <div className="text-cass-slate text-sm">Loading…</div>;
  const set = (k, v) => setW({ ...w, [k]: v });
  const save = async () => { await api.put("/welcome", w); toast.success("Welcome screen saved"); };

  return (
    <div className="space-y-4 max-w-3xl" data-testid="welcome-admin">
      <Card className="p-6 rounded-md space-y-3">
        <p className="text-sm text-cass-slate">Shown to a client immediately after they accept &amp; sign. Use <code className="bg-cass-bone px-1 rounded">{"{business_name}"}</code> to insert the client's business name.</p>
        <div>
          <Label className="text-xs">Team photo</Label>
          <div className="flex items-center gap-2 mt-1">
            <Button type="button" variant="outline" size="sm" onClick={() => setPick(true)} data-testid="welcome-image-btn"><ImageIcon className="w-4 h-4 mr-1" />Choose image</Button>
            {w.team_image_url && <img src={abs(w.team_image_url)} alt="team" className="h-12 rounded" />}
            {w.team_image_url && <Button type="button" variant="ghost" size="sm" onClick={() => setW({ ...w, team_image_url: "", team_image_path: "" })}>Remove</Button>}
          </div>
        </div>
        <div><Label className="text-xs">Heading</Label><Input value={w.heading || ""} onChange={(e) => set("heading", e.target.value)} data-testid="welcome-heading" /></div>
        <div><Label className="text-xs">Body message</Label><Textarea rows={5} value={w.body || ""} onChange={(e) => set("body", e.target.value)} data-testid="welcome-body" /></div>
        <div className="grid grid-cols-2 gap-3">
          <div><Label className="text-xs">Button label</Label><Input value={w.cta_label || ""} onChange={(e) => set("cta_label", e.target.value)} data-testid="welcome-cta-label" /></div>
          <div><Label className="text-xs">Button link (URL)</Label><Input value={w.cta_url || ""} onChange={(e) => set("cta_url", e.target.value)} data-testid="welcome-cta-url" /></div>
        </div>
        <Button className="bg-cass-navy text-white" onClick={save} data-testid="welcome-save-btn"><Save className="w-4 h-4 mr-1" />Save welcome screen</Button>
      </Card>
      <ImagePicker open={pick} onOpenChange={setPick} onSelect={(path, url) => { setW({ ...w, team_image_path: path, team_image_url: url }); setPick(false); }} />
    </div>
  );
}
